import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LaudoHigienizacaoService } from 'src/app/services/LaudoHigienizacaoService/laudo-higienizacao.service';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-visualizar-laudo',
  templateUrl: './visualizar-laudo.component.html',
  styleUrls: ['./visualizar-laudo.component.scss']
})
export class VisualizarLaudoComponent implements OnInit {
  pkSrvc: number = 0;
  pdfBase64: string = '';
  isLoading: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private laudoHigienizacaoService: LaudoHigienizacaoService,
    public swalAlert: SwalAlertService
  ) {}

  ngOnInit(): void {
    this.activateRoute();
  }

  getLaudo(): void {
    if (!this.pkSrvc) {
      this.swalAlert.showAlertOnConfirmNavigate(
        'Atenção!',
        'Não foi possível encontrar o laudo!',
        'warning',
        'inserir-informacoes-laudo'
      );
    }
    this.isLoading = true;
    this.laudoHigienizacaoService
      .GetReceiptLaudoHigienizacaoById(this.pkSrvc)
      .subscribe({
        next: res => {
          this.isLoading = false;
          this.pdfBase64 = 'data:application/pdf;base64,' + res.ReportBase64;
        },
        error: err => {
          this.isLoading = false;
          this.swalAlert.showAlertOnConfirmNavigate(
            'Atenção!',
            'Não foi possível encontrar o laudo!',
            'warning',
            'inserir-informacoes-laudo'
          );
        }
      });
  }

  activateRoute() {
    this.route.queryParams.subscribe(params => {
      this.pkSrvc = params['PK_LAUD_SRVC'];
    });
    this.getLaudo();
  }
}
